<template>
  <div
    class="cardCode-manage"
    v-loading="loading"
    :element-loading-text="loadingText"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="cardCode-manage-back"></div>
    <div class="cardCode-manage-content">
      <div
        class="cardCode-manage-top"
        v-for="item in hourseInfoList"
        :key="item.openId_heating_card_id"
        @click="handleItemClick(item)"
      >
        <div class="room-top">
          <div class="room-user">{{item.owner_name ? item.owner_name.split("").map((item1, index) =>  index % 2 == 0?"*":item1).join("") : '-'}}</div>
          <div style="color:#E46471" @click.stop="removeBind(item.heating_card_num)">解除绑定</div>
        </div>
        <div class="room-address">{{item.building_name + (item.unit_number ? item.unit_number.split("").map((item1, index) =>  index % 2 == 0?"*":item1).join("") : '-') + "单元" + (item.hourse_number?item.hourse_number:"-")}}</div>
        <div class="room-card">房屋卡号：{{item.heating_card_num}}</div>
      </div>
    </div>

    <div class="cardCode-manage-buttom">
      <div>
        <el-button
          style="background: #007b83; color: #fff; border: none; padding: 4%"
          @click="handleConfirmClick"
          >绑定卡号</el-button
        >
      </div>
    </div>
    <div class="mark-index" v-if="markFlag">
      <div style="height: 2rem">
        <div style="text-align: right; padding: 0.1rem 0.15rem; color: #aaaaaa">
          <i class="iconfont iconguanbi" @click="markFlag = false"></i>
        </div>
        <div style="margin-top: 0.4rem">
          <div style="color: #007b83">请您再次确认房屋{{ cardCode }}解绑</div>
          <div class="mark-binding">
            <el-button
              type="primary"
              style="
                width: 0.6rem;
                height: 0.3rem;
                padding: 0 0;
                background: #007b83;
                border: none;
                color: #fff;
              "
              @click="affirmBinding"
              >确认</el-button
            >
            <el-button
              style="
                width: 0.6rem;
                height: 0.3rem;
                padding: 0 0;
                border: 1px solid #007b83;
                color: #007b83;
              "
              @click="markFlag = false"
              >取消</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      loadingText: '',
      hourseInfoList: [],
      markFlag: false,
      bindingFlag: false,
      cardCode: '',
    };
  },
  mounted() {
    document.title = '卡号管理';
    this.getBindingInfo();
  },
  methods: {
    async getBindingInfo() {
      this.loading = true;
      this.loadingText = '正在查询您的所有卡号信息，请稍等';
      const res = await this.$http.get(`${this.$url.globalurl}/wxUser`);
      if(res.code == 200) {
        this.hourseInfoList = res.result
        this.hourseInfoList.forEach(item=>{
          item.building_name = item.building_name?(item.building_name.split('').map((item1, index) =>  item1>=0&&item1<=9 ? '*' : item1).join("")):'-'
        })
        this.loading = false;
      }
    },
    //点击卡片
    async handleItemClick(value) {
      const res = await this.$http.put(`${this.$url.globalurl}/wxUser/${value.heating_card_num}`);
      if (res.code == 200) {
        this.$router.push({
          name: 'index',
        });
      }
    },
    // 绑定卡号
    handleConfirmClick() {
      this.$router.push({
        name: 'bindingInfo',
      });
    },
    //解除绑定
    removeBind(value) {
      this.markFlag = true;
      this.cardCode = value;
    },
    // 确定解绑
    async affirmBinding() {
      const res = await this.$http.delete(`${this.$url.globalurl}/wxUser/${this.cardCode}`);
      if (res.code == 200) {
        this.getBindingInfo();
      }
      this.markFlag = false;
    },
  },
};
</script>
<style lang='scss' scoped>
@import url(cardCodeManage.scss);
</style>
